<template>
  <div
    class="shadow-card relative overflow-hidden rounded-lg bg-white px-4 py-6 md:px-6 md:py-8"
  >
    <div
      v-if="progress"
      class="absolute right-0 top-0 rounded-l-full bg-secondary px-3 py-1"
    >
      <span class="block text-xs leading-none text-white">{{ progress }}</span>
    </div>

    <EmptySection v-if="!data.length" :title="__('Add your perks')">
      <template #icon>
        <Icon class="text-xl text-zinc-200" name="loyalty" is-filled />
      </template>
    </EmptySection>

    <div v-else class="flex flex-wrap gap-x-3 gap-y-2">
      <span
        v-for="perk in data"
        :key="perk.id"
        class="rounded-lg border border-secondary px-3 py-1 leading-tight text-zinc-800"
      >
        {{ perk.name }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Icon } from '@/components/block/icon';
  import { EmptySection } from '@/pages/components/empty-section';

  const props = defineProps({
    data: {
      type: Array,
      required: true
    },
    fields: {
      type: Object,
      required: true
    }
  });

  const progress = computed(() => {
    return props.fields.total
      ? `${props.fields.completed}/${props.fields.total}`
      : '';
  });
</script>
